export default "__VITE_ASSET__D$sX_lPE__"